import type { Photo } from 'app/types/commonTypes.type';
import type { ListingVideo } from 'app/types/listingDetails.type';
import {
  FullscreenOverlayBackdrop,
  FullscreenOverlayBody,
  FullscreenOverlayContent,
  FullscreenOverlayFooter,
  FullscreenOverlayPortal,
  FullscreenOverlayRoot,
} from '../../../ui/FullscreenOverlay';
import { SpokeFooterCTAs } from '../SpokeFooterCTAs';
import { ListingHeaderActions } from '../ListingHeaderActions';
import { HaloSpokeHeader } from '../HaloSpokeHeader';
import { MediaCenterContent } from './MediaCenterContent';
import * as styles from './mediaCenter.styles';
import type { MediaCenterTab } from './MediaCenterTabs';

type MediaCenterProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  photos: Array<Photo>;
  tourUrls: Array<string>;
  tourLabels?: Array<string>;
  has3dTour: boolean;
  hasVideos?: boolean;
  hasStreetView?: boolean;
  videos?: Array<ListingVideo>;
  previewPhoto?: Photo;
  initialTab?: MediaCenterTab;
  streetViewLat?: number;
  streetViewLon?: number;
};

export const MediaCenter = ({
  open,
  onOpenChange,
  photos,
  tourUrls,
  tourLabels = [],
  has3dTour,
  hasVideos,
  hasStreetView,
  videos = [],
  previewPhoto,
  initialTab = 'photos',
  streetViewLat,
  streetViewLon,
}: MediaCenterProps) => {
  const headerActions = <ListingHeaderActions />;

  return (
    <FullscreenOverlayRoot open={open} onOpenChange={onOpenChange}>
      <FullscreenOverlayPortal>
        <FullscreenOverlayBackdrop>
          <FullscreenOverlayContent variant="standard" ariaLabelledBy="overlay-title">
            <HaloSpokeHeader title="Media center" actions={headerActions} layout="sticky" variant="standard" />

            <FullscreenOverlayBody padding="edge-to-edge" variant="standard">
              <MediaCenterContent
                open={open}
                photos={photos}
                tourUrls={tourUrls}
                tourLabels={tourLabels}
                has3dTour={has3dTour}
                hasVideos={hasVideos}
                hasStreetView={hasStreetView}
                videos={videos}
                previewPhoto={previewPhoto}
                initialTab={initialTab}
                headerActions={headerActions}
                streetViewLat={streetViewLat}
                streetViewLon={streetViewLon}
              />
            </FullscreenOverlayBody>

            <FullscreenOverlayFooter variant="equal-width" overlayVariant="standard">
              <div className={styles.footerActions}>
                <SpokeFooterCTAs />
              </div>
            </FullscreenOverlayFooter>
          </FullscreenOverlayContent>
        </FullscreenOverlayBackdrop>
      </FullscreenOverlayPortal>
    </FullscreenOverlayRoot>
  );
};
